// Store de alertas de completitud EN VIVO (2026-09-10) — mismo patrón que
// especialidadDemoOverride.ts (Set<Listener> + getter/setter consumidos con
// useSyncExternalStore), pero a propósito SIN localStorage: un aviso de "te
// faltó completar tal cosa en la consulta que acabás de dejar" es efímero de
// la sesión del navegador — no debe sobrevivir a un F5 ni arrastrarse a la
// sesión de otro día. Alimentado por PatientChartPage.tsx (al desmontarse,
// ver el useEffect con cleanup ahí) y leído por AlertaCompletitudPopup.tsx
// (montado como hermano de <AppRoutes/> en App.tsx).
import type { HallazgoIncompleto } from './chequeoCompletitudConsulta';

type Reporte = { patientId: string; hallazgos: HallazgoIncompleto[] };
type Listener = () => void;

const listeners = new Set<Listener>();
let reporteActual: Reporte | null = null;

export function reportarHallazgos(patientId: string, hallazgos: HallazgoIncompleto[]): void {
  reporteActual = { patientId, hallazgos };
  listeners.forEach((l) => l());
}

export function getUltimoReporte(): Reporte | null {
  return reporteActual;
}

export function limpiarReporte(): void {
  reporteActual = null;
  listeners.forEach((l) => l());
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
